module.exports = __webpack_public_path__ + "static/media/Tywin Lannister 2.071e5a1f.jpg";